import Vue from 'vue'


import App from '@/App.vue'
import store from '@/store'
import Lottie from 'vue-lottie'
import './registerServiceWorker'
// i18n Always before router
import i18n from './initI18n'
import router from './router'

import {configuration} from '../configuration'
import VueResource from 'vue-resource'
import Vue2TouchEvents from 'vue2-touch-events'
import VueMq from 'vue-mq'
import VueLazyload from 'vue-lazyload'

import Firebase from './modules/firebase'
import IndexedDb from './modules/indexedDb'
import I18n from './modules/i18n'
import ENUM from './assets/ENUM'
import Storage from './helpers/storage'

const backwardLanguage = configuration.languages.backwardLanguage


Vue.config.productionTip = false

Firebase.init()

// Remove img drag on firefox for cards system on desktop
document.addEventListener('dragstart', function (e) {
    e.preventDefault()
})

// filters
Vue.filter('capitalizeFirstLetter', function (string) {
    if (string) {
        string = string.toString()
        return string.charAt(0).toUpperCase() + string.slice(1)
    }
    return ''
})
Vue.filter('toUpperCase', function (string) {
    if (string) {
        string = string.toString()
        return string.toUpperCase()
    }
    return ''
})

Vue.mixin({
    computed: {
        isDesktop: function () {
            return this.$mq === 'lg'
        },
        isReverseLang: function () {
            const lang = I18n.get(this)
            return lang === 'ar-sa'
        },
        ENUM: function () {
            return ENUM
        }
    },
    methods: {
        octetConverter(kilos) {
            if (typeof kilos === 'number') {
                if (kilos < 1000) {
                    return `${kilos.toFixed()} ${this.$t('global_capacity_KB')}`
                } else if (kilos < 1000000) {
                    return `${(kilos/1000).toFixed()} ${this.$t('global_capacity_MB')}`
                } else if (kilos < 1000000000) {
                    return `${(kilos/1000000).toFixed()} ${this.$t('global_capacity_GB')}`
                } else {
                    return `${(kilos/1000000000).toFixed()} ${this.$t('global_capacity_teraoctet')}`
                }
            }
            return kilos
        },
        makeHref(url) {
            if(store.getters.isNewPrivacy && url === '/privacy.html') {
                url = '/privacy-aftermay2025.html'
            }
            let lang = I18n.get(this)
            switch (lang) {
                case 'de-at':
                    lang = 'de-de'
                    break
            }
            return `https://cleanfox.io/${lang}${url}`
        },
        clearStaticLinksRedirection(text = '') {
            //replace url to privacy page for external link while waiting for the day of standardization of the ulrs of the static privacy page
            if (store.getters.isNewPrivacy) {
                text = text.replaceAll('](privacy_policy)', `](/${Storage.getItem('lang')}/privacy-aftermay2025.html)`)
                text = text.replaceAll('](privacy)', `](/${Storage.getItem('lang')}/privacy-aftermay2025.html)`)
            } else {
                text = text.replaceAll('](privacy)', `](/${Storage.getItem('lang')}/privacy.html)`)
            }
            text = text.replaceAll('](terms)', `](/${Storage.getItem('lang')}/terms.html)`)
            text = text.replaceAll('](cookie_policy)', `](/${Storage.getItem('lang')}/cookies-policy.html)`)
            text = text.replaceAll('](health_data)', `](/${Storage.getItem('lang')}/health-data-privacy.html)`)
            return text
        }
    }
})

Vue.use(VueMq, {
    breakpoints: { // default breakpoints - customize this
        sm: configuration.size.tablet,
        md: configuration.size.desktop,
        lg: Infinity
    },
    defaultBreakpoint: 'sm' // customize this for SSR
})

Vue.use(Lottie)
Vue.use(VueResource)
Vue.use(Vue2TouchEvents)


Vue.use(VueLazyload, {
    preLoad: 1
})

IndexedDb.init()

router.beforeEach((to, from, next) => {
    if (store.getters.anonymousUser && to.path !== '/user-form') {
        next({path: '/user-form'})
    }
    if (to.redirectedFrom) {

        const lang = to.redirectedFrom.split('/')[1]
        if (lang in backwardLanguage) {
            // update language
            I18n.set(Vue, backwardLanguage[lang])
            // new route
            const regex = new RegExp(`^/${lang}/?$`)
            if (regex.test(to.redirectedFrom)) {
                next({path: '/'}).catch(() => {
                })
            }
            const splited = to.redirectedFrom.split('/')[2]
            if (splited === 'partner') {
                next({path: `/partner/${to.redirectedFrom.split('/')[3]}`}).catch(() => {
                })
            }
            splited.shift()
            splited.shift()
            const newPath = splited.join('/')

            next({path: `/${newPath}`}).catch(() => {
            })
        }
    }
    next()
})

new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
}).$mount('#app')
